import React from 'react'
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import StripeGenericPaymentForm from './StripeGenericPaymentForm'

const PUBLIC_KEY = process.env.REACT_APP_STRIPE_KEY

const stripeTestPromise = loadStripe(PUBLIC_KEY)
function StripeGenericContainer(props) {
    return (
        <Elements stripe={stripeTestPromise}>
            <StripeGenericPaymentForm baseObject={props.baseObject} setBaseObject={props.setBaseObject} setAlert={props.setAlert} renewCredits={props.renewCredits} handlePurchase={props.handlePurchase} isAdSpend={props.isAdSpend} setPurchaseComplete={props.setPurchaseComplete} />
        </Elements>
    )
}

export default StripeGenericContainer